import { render, staticRenderFns } from "./ColaboradoresForm.vue?vue&type=template&id=11a01772&"
import script from "./ColaboradoresForm.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports